import React from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';
import './NavLink.css';

const NavLink = ({ children, to, onClick, className = '' }) => {
    return (
        <RouterNavLink 
            to={to} 
            onClick={onClick}
            className={({ isActive }) => 
                `nav-link ${className} ${isActive ? 'nav-link-active' : ''}`
            }
        >
            {children}
        </RouterNavLink>
    );
};

export default NavLink;
